import React, { useEffect, useState } from "react";
import "./App.css";
import customLogo from "./customlogo.png";
import { parseRecipe } from "./utils/parseRecipe";


function App() {
  const [recipeText, setRecipeText] = useState("");
  const [ingredients, setIngredients] = useState([]);
  const [totals, setTotals] = useState({
    totalKcal: null,
    totalProtein: null,
    totalFiber: null,
    per100gKcal: null,
    per100gProtein: null,
    per100gFiber: null
  });
  const [foodInfo, setFoodInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch("/food_info.json")
      .then(r => r.json())
      .then(setFoodInfo)
      .catch(() => setError("Kunde inte ladda livsmedelsdata"));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!recipeText.trim()) {
      setError("Please enter a recipe.");
      return;
    }
    if (!foodInfo) return;

    setLoading(true);
    setError("");

    try {
      const result = parseRecipe(recipeText, foodInfo);

      setIngredients(result.parsed_ingredients);

      setTotals({
        totalKcal: result.totals.total_kcal,
        totalProtein: result.totals.total_protein,
        totalFiber: result.totals.total_fiber,
        per100gKcal: result.totals.kcal_per_100g,
        per100gProtein: result.totals.protein_per_100g,
        per100gFiber: result.totals.fiber_per_100g
      });
    } catch (err) {
       console.error("PARSE ERROR:", err);
      setError("Fel vid beräkning");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app">
      <h1 className="app-title">
        <img src={customLogo} alt="Receptkalkyl logo" className="title-logo" />
        Receptkalkyl – beräknar näringsvärden för recept
      </h1>

      <form onSubmit={handleSubmit}>
        <div className="input-container">
          <textarea
            value={recipeText}
            onChange={(e) => setRecipeText(e.target.value)}
            rows={15}
            placeholder="här skriver eller klistrar du in receptet och klickar sedan på beräkna knappen"
            className="recipe-textarea"
          />

          <div className="ingredients-list">
            {ingredients.length === 0 ? (
              <div style={{ padding: "10px", color: "#666", fontStyle: "italic" }}>
                här visas de hittade ingredienserna efter att du matat in ett recept
              </div>
            ) : (
              ingredients.map((ing, index) => {
                const hasAmount = ing.amount != null;
                const hasUnit = ing.unit && ing.unit.trim() !== "";
                const color = (hasAmount && hasUnit) ? "black" : "red";
                const backgroundColor = index % 2 === 0 ? "#f9f9f9" : "white";

                return (
                  <div
                    key={index}
                    className="ingredient-item"
                    style={{ color, backgroundColor }}
                  >
                    <span className="ingredient-content">
                      {ing.name || ing.ingredient || "Unknown ingredient"}

                      {!hasAmount && <span className="error-text">(saknar mått)</span>}
                      {!hasUnit && <span className="error-text">(saknar enhet)</span>}

                      {hasAmount && <span> {ing.amount}</span>}
                      {hasUnit && <span> {ing.unit}</span>}
                    </span>
                  </div>
                );
              })
            )}
          </div>
        </div>

        <button type="submit" className="calculate-btn" disabled={loading || !foodInfo}>
          Beräkna
        </button>
      </form>

      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}

      {error && <div className="error-message">{error}</div>}

      <div className="results">
  <h2>Resultat</h2>

        <div className="results-container">
          <div className="totals-container">
            <div className="total-box">
              <h3>Totalt</h3>
              <p><strong>Kcal:</strong> {totals.totalKcal?.toFixed(0) ?? "-"}</p>
              <p><strong>Protein:</strong> {totals.totalProtein?.toFixed(1) ?? "-"} g</p>
              <p><strong>Fiber:</strong> {totals.totalFiber?.toFixed(1) ?? "-"} g</p>
            </div>

            <div className="total-box">
              <h3>Per 100g</h3>
              <p><strong>Kcal:</strong> {totals.per100gKcal?.toFixed(0) ?? "-"}</p>
              <p><strong>Protein:</strong> {totals.per100gProtein?.toFixed(1) ?? "-"} g</p>
              <p><strong>Fiber:</strong> {totals.per100gFiber?.toFixed(1) ?? "-"} g</p>
            </div>
          </div>

          {/* 🟡 Instructions box on the right */}
          <div className="instructions">
            <h3>Instruktioner</h3>
            <ul>
              <li>Skriv en ingrediens per rad med mått först. t.ex. <code>1/2 dl mjöl</code> eller <code>2,5 krm bakpulver</code></li>
              <li>Tillåtna mått: <code>dl, cl, ml, l, liter, msk, tsk, krm, g, gram, kg, hg</code></li>
              <li>Det fungerar oftast bättre att söka i singular (exempel: <em>morot</em> istället för <em>morötter</em>).</li>
              <li>Namnen som visas i ingredienslistan är från Livsmedelsverkets databas och matchas mot det du skriver i textrutan.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
